<template>
  <div>
    <div class="grid-container">
      <div class="grid-x grid-padding-x grid-padding-y">
        <div class="cell">
          <nav aria-label="You are here:" role="navigation">
            <ul class="breadcrumbs">
              <li>
                <router-link :to="{name: 'home'}">
                  Home
                </router-link>
              </li>
              <!-- <li><a href="#0">Features</a></li>
                    <li class="disabled">Gene Splicing</li> -->
              <li v-show="$route.name!=='search'">
                <span class="show-for-sr">Current: </span>
                {{ (model ? model.name : '') }}
              </li>
              <li v-if="$route.name==='search'">
                <span class="show-for-sr">Current: </span>
                Search
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div id="yourset" class="grid-container">
      <div class="grid-x grid-padding-x">

        <!--Categories sidebar-->
        <div v-if="$route.name !== 'search'" class="cell large-2 medium-2">
          <!--Specific Selected Catalog-->
          <ul v-if="model && model.children" class="menu vertical product-catalog">
            <li class="menu-text text-uppercase">
              {{ model.name }}
            </li>
            <li v-for="(item, index) in model.children" :key="index">
              <a
                href="javascript:void(0)"
                @click="onSubCategoryChange(index)"
                class="sub-category-item"
                style="text-transform:capitalize;"
                :class="[{ category: model.id !== item.id }, { subCategoryActive: subCategoryIndex === index }]"
              >
                {{ item.name }}
              </a>
            </li>
          </ul>
          
        </div>

        <div class="cell large-auto medium-auto">
          <!--Search header-->
          <div class="grid-x callout primary radius" style="border: none;">
            <div class="cell large-6">

              <nav role="navigation" v-if="$route.name==='search'">
                <ul class="menu search-section">
                  <li class="menu-text" style="font-weight: 300; color: #fff;">
                    <span style="">All</span>
                  </li>
                </ul>
              </nav>

              <nav role="navigation" v-else>
                <ul class="menu search-section" style="  color: #fff;">
                  <li v-if="!selectedSubCategory" class="menu-text" style="font-weight: 300;">
                    <span v-if="model" style="">{{ model.name }}</span>
                  </li>
                  <li v-if="selectedSubCategory" class="" style="display:inherit;">
                    <a href="javascript:void(0);" @click="subCategoryIndex=-1;getProductsByCatalogId(model.id)"
                    style="  color: #fff;">{{ model.name }}</a>
                  </li>
                  <li v-if="selectedSubCategory" class="menu-text" style="font-weight: 300; text-transform: capitalize;">
                    <span style="">
                      {{selectedSubCategory.name}}
                    </span>
                    
                  </li>
                </ul>
              </nav>


            </div>
            <div class="cell large-6">
              <div class="grid-x ">
                <div class="cell large-auto">
                  <input
                    type="search"
                    placeholder="searh product..."
                    v-model="searchStr"
                    style="margin:0;max-width: 100%;"
                  />
                </div>
                <div class="cell large-shrink">
                  <button type="button" class="button clear" style="margin: 0;">
                    <i class="fi-magnifying-glass"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!--Search result-->
          <div
            v-if="!loadingProducts && productFiltered.length"
            class="grid-x grid-padding-y"
            :class="$route.name === 'search' ? 'large-up-5 medium-up-4 small-up-2' : 'large-up-4 medium-up-3 small-up-2'"
          >
            <div
              class="cell "
              v-for="(item, index) in productFiltered"
              :key="index"
              @mouseover="mouseOverIdx = index"
              @mouseleave="mouseOverIdx = -1"
            >
              <div class="grid-x product-container">
                <div class="cell">
                  
                  <router-link :to="{ name: 'product-detail',
                      params: {
                        productId: item.id,
                        entity: item,
                      },
                    }"
                  class="card card-product radius"
                  :class="{ shadow: mouseOverIdx === index }">
                  
                  <product-card :item="item" />

                  </router-link>

                </div>
              </div>
            </div>
          </div>

          <div
            v-if="!loadingProducts && productFiltered.length === 0"
            class="grid-x grid-padding-x grid-padding-y large-up-4"
          >
            <!-- Item not found -->
            <div class="cell ">
              <div class="grid-x">
                <div class="cell">
                  <div class="card radius">

                    <div class="card-section">
                      <div class="grid-x text-center grid-padding-y">
                        <a href="javascript:void;" class="cell ellipsis">
                          No data to display
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="loadingProducts"
            class="grid-x grid-padding-x grid-padding-y large-up-4"
          >
            <!-- Item not found -->
            <div class="cell ">
              <div class="grid-x">
                <div class="cell">
                  <div class="card radius">

                    <div class="card-section">
                      <div class="grid-x text-center grid-padding-y">
                        <span class="cell ellipsis " style="">
                          loading...
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import productDataService from "@/store.product/services/main-service.js";
import catalogDataService from "@/store.catalog/services/main-service.js";
import configService from "@/app/config-service.js";

export default {
  name: "productPage",
  props: ["query", "catalog"],
  mixins: [require("@/app/mixins/foundation")],
  components: {
    "product-card": () => import("@/store.product/components/product-card")
  },
  data() {
    return {
      model: { id: this.catalog, name: '', children: [] }, //category(department)

      productList: [],
      searchStr: "",
      subCategoryIndex: -1,

      initialized: false,
      loading: true,
      errored: false,
      loadingProducts: true,

      mouseOverIdx: -1, //related products effect
    };
  },
  metaInfo(){
    return {
      title: (this.model) ? this.model.name : '',
      titleTemplate: '%s | OneBuy'
    }
  },
  computed: {
    baseUrl() {
      return configService.baseUrl;
    },
    productFiltered() {
      if (this.searchStr) {
        let _this = this;
        return this.productList.filter(function(e) {
          let properties = Object.values(e);
          return properties.some(function(item) {
            if (item) {
              let type = Object.prototype.toString.call(item);
              if (type === "[object Object]") {
                return Object.values(item).some(
                  (x) =>
                    x &&
                    x
                      .toString()
                      .toLocaleLowerCase()
                      .includes(_this.searchStr.toLocaleLowerCase())
                );
              } else if (type === "[object String]") {
                return item
                  .toString()
                  .toLocaleLowerCase()
                  .includes(_this.searchStr.toLocaleLowerCase());
              }
            }
            return false;
          });
        });
      } else {
        return this.productList;
      }
    },
    selectedSubCategory(){
      return this.subCategoryIndex > -1 ? this.model.children[this.subCategoryIndex] : null;
    }
  },
  mounted() {
    this.getProductsByCatalogId(this.model.id);

    //This gets all categories and sub-categories
    if (this.$route.name !== 'search'){
      this.getCategoriesTree();
    }
  },
  methods: {
    async getCategoriesTree(){
      try {
        this.loading = true;
        const {data} = await catalogDataService.getTree();
        this.model = data.find(e=>e.id===parseInt(this.model.id));
      }catch (error) {
          this.errored = true;
          console.error(error);
      }finally{
          this.loading = false;
          this.initialized = true;
      }
    },
    async getProductsByCatalogId(catalogId) {
      try {
        this.loadingProducts = true;
        const {data} = await (catalogId && catalogId > 0 ? 
        productDataService.getProductsByCatalogId(catalogId):
        productDataService.get());

        //Remove is active = false

        this.productList = data.filter(e=>e.isActive === true);
      }catch (error) {
          this.errored = true;
          console.error(error);
      }finally{
          this.loadingProducts = false;
          this.initialized = true;
      }
    },
    onSubCategoryChange(subCategoryIndex) {
      this.subCategoryIndex = subCategoryIndex;
      this.getProductsByCatalogId(this.model.children[subCategoryIndex].id);
    }
  },
};
</script>

<style lang="scss">
@import "./../../assets/sass/settings/settings";

.owl-carousel .item {
  padding: 0 !important;
}

#yourset .callout{
  background: var(--primary-color);
}

#yourset .menu.vertical li,
#yourset .menu.vertical a {
  padding-left: 0;
}

.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}


.search-section li:not(:last-child)::after {
    position: relative;
    margin: 6px -0rem;
    opacity: 1;
    content: "/";
    color: #cacaca;
}

.bg-slider{
  background-size: cover;
  background-position: 50% 53%;
}

.sub-category-item{
  padding-left:1rem !important;
  
  -moz-transition: background .3s ease-in;
    -o-transition: background .3s ease-in;
    -webkit-transition: background .3s ease-in;
    transition: background .3s ease-in;
}
.sub-category-item:hover {
    //transition: background .3s ease-in;
    //background-color: var(--primary-color);
    background-color: #e1edf8;
}
</style>
